import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../contexts/AuthContext";
import {addDoc, collection, serverTimestamp} from "firebase/firestore";
import {firestore} from "../firebase";

// ------------------------------
// Firestore 저장 함수
// ------------------------------
const saveApplicant = async (level, data) => {
  await addDoc(collection(firestore, `Festival_${level}`), {
    ...data,
    createdAt: serverTimestamp(),
  });
};

// ------------------------------
// 메인 컴포넌트
// ------------------------------
const FestivalRegistration = () => {
  const {signup} = useAuth();

  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Phone, setPhone] = useState("");
  const [Pass, setPass] = useState("");
  const [Pass2, setPass2] = useState("");

  // ★ 초/중/고 선택
  const [Level, setLevel] = useState("e"); // 기본값: 초등부

  const navigate = useNavigate();

  // ------------------------------
  // 제출 처리
  // ------------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (Pass !== Pass2) {
      alert("비밀번호가 일치하지 않습니다.");
      setPass("");
      setPass2("");
      return;
    }

    try {
      // 회원가입
      const result = await signup(Email, Pass, Name, Phone);
      if (!result?.user?.uid) return;

      const data = {
        name: Name,
        email: Email,
        phone: Phone,
        uid: result.user.uid,
        level: Level,
      };

      // ★ 선택한 레벨만 저장
      await saveApplicant(Level, data);

      navigate("/FestivalRegistrationSuccess", {
        state: {Name, Email},
      });
    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        alert("이미 가입된 이메일입니다. 로그인 페이지로 이동해주세요.");
      } else {
        alert("회원가입 중 오류가 발생했습니다: " + error.message);
      }
    }
  };

  // ------------------------------
  // UI
  // ------------------------------
  return (
    <main>

      {/* 반응형 중앙 정렬 */}
      <section className="min-vh-100 d-flex justify-content-center align-items-center bg-light py-5">

        <div
          className="w-100 px-3"
          style={{
            maxWidth: "600px"    // 데스크탑 기준 폼 폭 제한
          }}
        >

          {/* 제목 */}
          <div className="text-center mb-4">
            <img src="/assets/images/element/03.svg" className="h-40px mb-3" alt="" />
            <h2 className="fw-bold">초코파이썬 코딩 타자대회 참가 신청</h2>
            <p className="lead text-muted">
            참가자 전원에게 초코파이썬 프리미엄 라이선스를 드립니다.
            </p>
          </div>

          {/* FORM CARD */}
          <form
            onSubmit={handleSubmit}
            className="bg-white shadow rounded-4 p-4 p-md-5"
            style={{width: "100%"}}
          >

            {/* 참가 부문 */}
            <div className="mb-4">
              <label className="form-label fw-bold">참가 부문 *</label>
              <div className="d-flex flex-wrap gap-3 mt-2 align-items-center">

                <label className="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="level"
                    value="e"
                    checked={Level === "e"}
                    onChange={() => setLevel("e")}
                  />
                  <span>초등부</span>
                </label>

                <label className="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="level"
                    value="m"
                    checked={Level === "m"}
                    onChange={() => setLevel("m")}
                  />
                  <span>중등부</span>
                </label>

                <label className="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="level"
                    value="h"
                    checked={Level === "h"}
                    onChange={() => setLevel("h")}
                  />
                  <span>고등부</span>
                </label>

              </div>
            </div>

            {/* 이름 */}
            <div className="mb-4">
              <label className="form-label fw-semibold">이름 *</label>
              <input
                type="text"
                className="form-control form-control-lg bg-light"
                placeholder="홍길동"
                value={Name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            {/* 이메일 */}
            <div className="mb-4">
              <label className="form-label fw-semibold">이메일 *</label>
              <input
                type="email"
                className="form-control form-control-lg bg-light"
                placeholder="test@gmail.com"
                value={Email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {/* 전화번호 */}
            <div className="mb-4">
              <label className="form-label fw-semibold">전화번호 *</label>
              <input
                type="tel"
                className="form-control form-control-lg bg-light"
                placeholder="010-1234-5678"
                value={Phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
            </div>

            {/* 비밀번호 */}
            <div className="mb-4">
              <label className="form-label fw-semibold">비밀번호 *</label>
              <input
                type="password"
                className="form-control form-control-lg bg-light"
                placeholder="영문 + 숫자 + 특수문자 8자리 이상"
                value={Pass}
                onChange={(e) => setPass(e.target.value)}
                required
              />
            </div>

            {/* 비밀번호 확인 */}
            <div className="mb-4">
              <label className="form-label fw-semibold">비밀번호 확인 *</label>
              <input
                type="password"
                className="form-control form-control-lg bg-light"
                placeholder="다시 입력"
                value={Pass2}
                onChange={(e) => setPass2(e.target.value)}
                required
              />
            </div>

            {/* 버튼 */}
            <div className="d-grid mt-4">
              <button className="btn btn-primary btn-lg" type="submit">
              등록
              </button>
            </div>

          </form>

        </div>
      </section>

    </main>
  );
};

export default FestivalRegistration;
